// extracted by mini-css-extract-plugin
export var active = "_6h-7";
export var container = "_6h-0";
export var evenWidth = "_6h-4";
export var large = "_6h-5";
export var outlet = "_6h-8";
export var slide = "_6h-2";
export var small = "_6h-6";
export var tab = "_6h-3";
export var tabs = "_6h-1";